export default function ActionToggleButton({
  isActive,
  onClick,
  activeLabel,
  inactiveLabel,
  activeIcon,
  inactiveIcon,
  variant = "elevated",
  stylesByVariant,
  focusRingClass,
  className = "",
  labelClassName = "",
}) {
  const selected = stylesByVariant[variant] || stylesByVariant.elevated;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-full sm:w-auto min-h-10 px-4 py-2 rounded-full flex items-center justify-center border font-medium focus:outline-none focus-visible:ring-2 transition-all duration-200 ${focusRingClass} ${
        isActive ? selected.active : selected.inactive
      } ${className}`}
    >
      <span className={`flex items-center ${labelClassName}`}>{isActive ? activeIcon : inactiveIcon}{isActive ? activeLabel : inactiveLabel}</span>
    </button>
  );
}
